import { getActiveDate } from "./dates";
import { getOutsideCalendar } from "./setOutsideCalendar";
import { getReadingViewType } from "./setReadingViewType";
export function updateURL() {
    const url = new URL(location.toString());
    const activeDate = getActiveDate();
    const type = getReadingViewType();
    const outsideCalendar = getOutsideCalendar();
    if (activeDate) {
        url.searchParams.set("date", activeDate.toLocaleDateString());
    }
    if (type) {
        url.searchParams.set("type", type);
    }
    if (outsideCalendar !== undefined) {
        url.searchParams.set("outsideCalendar", String(outsideCalendar));
    }
    history.pushState({}, "", url);
}
